import React from 'react';

const EmptyState = () => {
  return (
    <div className='flex-1 flex items-center justify-center bg-white border border-slate-200 rounded-lg h-full min-h-[calc(100vh-205px)]'>
      <div className='text-center'>
        <p className='text-slate-500 text-lg'>Selecciona un expediente para ver las interacciones</p>
      </div>
    </div>
  );
};

export default EmptyState;
